import { render, staticRenderFns } from "./Filterss.vue?vue&type=template&id=54337cc2"
import script from "./Filterss.vue?vue&type=script&lang=js"
export * from "./Filterss.vue?vue&type=script&lang=js"
import style0 from "./Filterss.vue?vue&type=style&index=0&id=54337cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports